<template>
    <ModalContent flat-chrome>
        <template slot="title">{{ $translate('title') }}</template>
        <template slot="content">
            <Warning type="info" icon="mdi-information-outline">
                {{ $translate('explanation') }}
                <p v-if="params.newWarehouse" class="mb-0 mt-2">{{ $translate('newWarehouse') }}</p>
            </Warning>
            <v-text-field v-model="name" :label="$translate('name')" outlined dense autofocus maxlength="128" hide-details="auto" :disabled="saving" :error-messages="error" @keydown.enter.prevent="submit" />
        </template>
        <template slot="bottom">
            <Button ghost class="my-2 my-sm-4 w-100 w-sm-auto" :text="$translate('cancel')" :disabled="saving" @click="hideModal()" />
            <Button class="my-2 my-sm-4 w-100 w-sm-auto ml-sm-3" :text="$translate('create')" :disabled="saving || !name.trim()" :loading="saving" @click="submit" />
        </template>
    </ModalContent>
</template>
<script>
import { mapActions } from 'vuex';
import GlobalMixins from '@/mixins/global';
export default {
    width: 600,
    mixins: [GlobalMixins],
    props: { params: { type: Object, required: true } },
    data: () => ({ name: '', saving: false, error: '' }),
    methods: {
        ...mapActions('mcl', ['hideModal']),
        async submit() {
            if (this.saving || !this.name.trim()) return;
            this.saving = true;
            this.error = '';
            try {
                const result = await this.params.submit(this.name.trim());
                this.hideModal({ result });
            } catch (error) {
                const data = error.response?.data || error.details || error.message || error;
                const flatten = value => typeof value === 'string' ? [value] : Object.values(value || {}).flatMap(flatten);
                this.error = flatten(data).join(' · ') || this.$translate('failed');
            } finally {
                this.saving = false;
            }
        },
    },
    i18n: { messages: {
        fr: { title: 'Créer le premier lieu de stockage', name: 'Nom du lieu *', explanation: 'À la validation, ce lieu sera créé immédiatement et tout le stock existant de l’entrepôt y sera transféré. La quantité totale de chaque produit restera identique. Vous pourrez ensuite ajouter d’autres lieux.', newWarehouse: 'L’entrepôt sera également enregistré avec les informations déjà saisies. Renseignez ses champs obligatoires avant de valider.', cancel: 'Annuler', create: 'Créer et transférer le stock', failed: 'La création du lieu a échoué.' },
        en: { title: 'Create the first storage location', name: 'Location name *', explanation: 'On confirmation, this location will be created immediately and all existing warehouse stock will be transferred to it. Each product’s total quantity will remain the same. You can then add other locations.', newWarehouse: 'The warehouse will also be saved with the details already entered. Complete its required fields before confirming.', cancel: 'Cancel', create: 'Create and transfer stock', failed: 'Could not create the location.' },
    } },
};
</script>
